import { BicycleRoute, BMNCity, Project } from '@/interfaces';
import bmnCities from '@/assets/data/locations.json';
import { Observable, Observer } from 'rxjs';
import imageModule from '@/assets/images/route-icon.png'; /* tslint:disable */
import imageModuleYellow from '@/assets/images/route-icon-yellow.png'; /* tslint:disable */
import imageModuleBlue from '@/assets/images/route-icon-blue.png'; /* tslint:disable */

export default class RouteService {
  public addRoutes(map: any, routes: BicycleRoute[]): any {
    const observable = Observable.create((observer: Observer<any>) => {
      map.loadImage(imageModule, (error, image) => {
        if (error) {
          throw error;
        }
        map.addImage('route-icon', image);
      });
      const layers = map.getStyle().layers;
      let firstSymbolId;
      layers.forEach((lay: any) => {
        if (lay.id === 'mirt-a2') {
          firstSymbolId = lay.id;
        }
      });
      routes.forEach((route: BicycleRoute, index: number) => {
        this.addRoute(map, route, firstSymbolId);
        if (index === routes.length - 1) {
          observer.next('complete');
          observer.complete();
        }
      });
    });
    return observable;
  }

  public addLabelsForProjects(map: any, projects: Project[]) {
    map.loadImage(imageModuleYellow, (error, image) => {
      if (error) {
        throw error;
      }
      map.addImage('route-icon-yellow', image);
    });
    map.loadImage(imageModuleBlue, (error, image) => {
      if (error) {
        throw error;
      }
      map.addImage('route-icon-blue', image);
    });
    projects.forEach(project => {
      project.roads.forEach(road => {
        const icon = (road.name.startsWith('a')) ? 'route-icon-blue' : 'route-icon-yellow';
        const textColor = (road.name.startsWith('a')) ? '#fff' : '#000';
        map.addLayer({
          id: `symbol-${project.id}`,
          type: 'symbol',
          source: `src-${project.id}`,
          layout: {
            'symbol-placement': 'line-center',
            'icon-rotation-alignment': 'viewport',
            'text-rotation-alignment': 'viewport',
            'icon-image': icon,
            'text-field': road.name.toUpperCase(),
            'icon-size': 0.25,
            'text-size': 11,
            'visibility': 'none'
          },
          paint: {
            'text-color': textColor,
          }
        });
        
      })
    });
  }

  public addLocations(map: any, locations: BMNCity[]) {
    const features = [];
    locations.forEach((location: BMNCity, index: number) => {
      const feature = {
        type: 'Feature',
        id: location.id,
        geometry: {
          type: 'Point',
          coordinates: location.coordinates
        }
      };
      features[index] = feature;
      this.addLocationSourceAndLayer(map, location, features);
    });
  }

  private addLocationSourceAndLayer(map: any, location: BMNCity, features: any) {
    const layers = map.getStyle().layers;
    let firstSymbolId;
    layers.forEach((lay: any) => {
      if (lay.id === 'mirt-a2') {
        firstSymbolId = lay.id;
      }
    });
    map.addSource(`src-${location.id}`, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features
      }
    });
    map.addLayer({
      id: `${location.id}`,
      type: 'circle',
      source: `src-${location.id}`,
      layout: {
        'visibility': 'none'
      },
      paint: {
        'circle-color': '#9155c6',
        'circle-radius':
        ['interpolate',
          ['linear'],
          ['zoom'],
          7.64,
          3,
          9.9,
          9
        ]
      },
    }, firstSymbolId);
  }

  private addRoute(map: any, route: BicycleRoute, firstSymbolId: string): void {

    let routeCoordinates: number[][] = [];
    route.cities.forEach(bmnCityId => {
      routeCoordinates.push(bmnCities.find(bmnCity => bmnCity.id === bmnCityId.id).coordinates.sort());
    });
    const color: string = route.status === 'planned' ? '#ffe500' : '#d9535a';
    const mapLayout = {
      lineJoin: 'round', lineCap: 'round', lineColor: color,
      lineWidth: { six: 1, ten: 8 }
    };
    map.addLayer({
      id: `${route.id}`,
      type: 'line',
      source: {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: {
            type: 'LineString',
            coordinates: routeCoordinates
          }
        }
      },
      layout: {
        'line-join': mapLayout.lineJoin,
        'line-cap': mapLayout.lineCap,
        'visibility': 'none'
      },
      paint: {
        'line-color': mapLayout.lineColor,
        'line-width': [
          'interpolate',
          ['linear'],
          ['zoom'],
          7.64,
          mapLayout.lineWidth.six,
          9.9,
          mapLayout.lineWidth.ten
        ]
      }
    }, firstSymbolId);
  }
}
